import { Http } from "@/@core/api/axios/interceptors";

export const allFamcosColegios = async (param) =>
  Http("GET", "/FamcosColegios/GetList?", param);

export const getFamcosColegio = async (id) =>
  Http("GET", `/FamcosColegios/Get?idColegio=${id}`);

export const createOrEditFamcosColegio = async (body, id = null) =>
  id
    ? Http("PUT", `/FamcosColegios/Update`, null, body)
    : Http("POST", "/FamcosColegios/Create", null, body);

export const deleteFamcosColegio = async (id) =>
  Http("DELETE", `/FamcosColegios/Delete?idColegio=${id}`);
